import axios from "axios";

const api = axios.create({
  baseURL: "https://voice.vocalbox.in", // your API URL
});

export default api;